// sometimes facebook strangely encodes campaign/adset/creative name
// so additional decoding of utm params
export function decode(s: string): string {
  try {
    s = s || '';
    s = s.replace(/\+/g, ' ');
    s = decodeURIComponent(s);
  }
  catch (ex) { }
  return s;
}
